module.exports = __webpack_public_path__ + "img/Baby.7828ff03.jpg";